// app/javascript/countdown.js
import simplyCountdown from 'simplycountdown.js';
import 'simplycountdown.js/dist/themes/default.css';

window.simplyCountdown = simplyCountdown;